var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-list col-md-8 "},[_c('div',{staticClass:"content-spacing"},[_c('product-buy',{on:{"resetPage":_vm.resetPage}}),_c('add-to-cart')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }